import { Link } from "react-router-dom";

export default function Logo({ light = true, size = "md", testid = "brand-logo" }) {
  const h = size === "lg" ? "h-20" : size === "sm" ? "h-11" : "h-14";
  return (
    <Link to="/" data-testid={testid} className="group flex items-center gap-3" aria-label="Immistop — home">
      <img src="/brand/logo.webp" alt="Immistop Limited crest" className={`${h} w-auto transition-transform duration-700 group-hover:scale-[1.04]`} width="160" height="147" />
      <span className="hidden flex-col whitespace-nowrap leading-none sm:flex">
        <span className={`font-serif text-[22px] font-medium tracking-[0.18em] ${light ? "text-ivory" : "text-navy"}`}>IMMISTOP</span>
        <span className={`mt-1 font-sans text-[9px] font-medium uppercase tracking-[0.34em] ${light ? "text-gold" : "text-gold-deep"}`}>Global Migration Advisory</span>
      </span>
    </Link>
  );
}
